module.exports = __webpack_public_path__ + "static/img/viral_22.500e4035.jpg";